export default "__VITE_ASSET__B4qMopcR__"